import { render } from "./LocationsSelector.vue?vue&type=template&id=6469936f"
import script from "./LocationsSelector.vue?vue&type=script&lang=js"
export * from "./LocationsSelector.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__